<template>
    <header id="banner">
        <h1>Gästehaus Erna</h1>
    </header>
</template>

<script>
    export default {
        name: "TheBanner"
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');

#banner {
    text-align:center;

    background: #78e222;
    background: linear-gradient(135deg, #78e222 0%,#67af3d 100%);

    h1 {
        font-family: 'Great Vibes', serif;
        font-weight: normal;
        color: black;
        font-size: 5.5rem;
        padding: 15px;
        margin: 0;
    }
}

.tablet #banner h1 {
    font-size: 4.5rem;
}

.mobile #banner h1 {
    font-size: 3.5rem;
}
</style>